<template>
  <DeleteConfirmationModal
    :show="show"
    :isLoading="isLoading"
    :title="titleText"
    :text="deleteText"
    @cancel="$emit('cancel')"
    @delete="removeFinding"
  />
</template>
<script>
import api from '@/api'
import mixin from '@/mixins/mixin'
import { mapGetters } from 'vuex'

import DeleteConfirmationModal from '@/components/Modals/DeleteConfirmationModal.vue'

export default {
  name: 'BulkDeleteConfirmation',

  mixins: [mixin],

  components: {
    DeleteConfirmationModal,
  },

  props: {
    show: Boolean,
    confirmTestID: {
      type: String,
      default: 'deleteConfirmation-button-confirm',
    },
    cancelTestID: { type: String, default: 'deleteConfirmation-button-cancel' },
    findingsToDeleteIds: {
      type: Array,
      default() {
        return []
      },
    },
    findingToDelete: {
      type: Object,
      default() {
        return {}
      },
    },
  },

  data() {
    return {
      isLoading: false,
    }
  },

  computed: {
    ...mapGetters(['organizationId']),

    deleteText() {
      if (this.findingsToDeleteIds.length === 1) {
        return this.findingToDelete?.revId
          ? this.$t('assignments.delete_completed_finding')
          : this.$t('assignments.delete_confirmation')
      } else {
        return this.$t('assignments.delete_confirmation', {
          count: this.findingsToDeleteIds.length,
        })
      }
    },

    titleText() {
      return this.$t('assignments.delete_title', {
        count: this.findingsToDeleteIds.length,
      })
    },
  },
  methods: {
    async removeFinding() {
      try {
        this.isLoading = true
        await api.findings.bulkDelete({
          organizationId: this.organizationId,
          findingsIds: this.findingsToDeleteIds,
        })
        this.$emit('success')
      } catch (err) {
        this.handleRequestError(err)
      } finally {
        this.isLoading = false
        this.$emit('close')
      }
    },
  },
}
</script>
